<!--begin header -->
<header class="header">

    <app-header></app-header>

</header>
<!--end header -->

<!--begin section-grey -->
<section class="section-white pb-3 page-content">

    <!--begin services-wrapper -->
    <div class="services-wrapper">

        <!--begin container -->
        <div class="container">

            <div class="row">
                <div class="col-12">
                    <h2 class="contact-us text-orange">Contact Us</h2>
                </div>
                <div class="col-12 mb-2 obanner sg">
                    <h4 >Singapore Office</h4>
                    <p>Address: 138 Cecil Street #04-01 Cecil Court, Singapore 069538 (By Appointment Only)</p>
                    <p>Email: help&#64;singx.co</p>
                    <p>Phone: +65 3158 4669</p>
                </div>
                <div class="col-12 mb-2 obanner hk">
                    <h4 >Hong Kong Office</h4>
                    <p>Address: L/20, Leighton Centre, 77 Leighton Road, Causeway Bay, HONG KONG (By Appointment Only)​</p>
                    <p>Email: help.hk&#64;singx.co</p>
                    <p>Phone: +852 5808 0270</p>
                </div>
                <div class="col-12 mb-2 obanner au">
                    <h4 >Australia Office</h4>
                    <p>Address: Level 4, 240 Queen Street, Brisbane, QLD 4000, Australia.</p>
                    <p>Email: help.au&#64;singx.co</p>
                    <p>Phone: +61 3 9917 4319</p>
                </div>
                <div class="col-12 mb-2 obanner bus">
                    <h4 >Business Queries</h4>
                    <p>Email: help.business&#64;singx.co</p>
                    <p>Phone: +65 3163 6148</p>
                </div>
            </div>

        </div>
        <!--end container -->

    </div>
    <!--end services-wrapper -->

</section>
<!--end section-grey -->

<app-footer></app-footer>